export default __webpack_public_path__ + "static/media/check-green.99a0b654.svg";